import { ComponentProps, ElementType, useEffect } from 'react'
import {
  ExcelUploader,
  ExcelValidation,
  ExcelConfirmation,
} from '@/Store/ui/organisms'
import { ExcelUploadProvider } from '@/Store/ui/context'
import { Steps } from '@/Store/ui/atoms'
import { useUserData } from '@/User/ui/context/UserDataProvider'
import { createApiTpvRepository } from '@/Store/infrastructure'
import { useExcelUpload } from '@/Store/ui/context/ExcelUploadContext'
import { navigationRoutes } from '@/Shared/ui/routers/data/navigationRoutes'

const getStepComponent = (
  step: Steps | undefined,
): ComponentProps<ElementType> => {
  switch (step) {
    case Steps.Upload:
      return ExcelUploader
    case Steps.Validation:
      return ExcelValidation
    case Steps.Confirmation:
      return ExcelConfirmation
  }
}

const TpvExcelPageInner = (): JSX.Element => {
  const { step } = useExcelUpload()

  const StepComponent = getStepComponent(step ?? Steps.Upload)

  return <StepComponent />
}

export const TpvExcelContainer = (): JSX.Element => {
  const { merchant } = useUserData()

  useEffect(() => {
    if (!merchant?.isParent || merchant?.isMasterGroup) {
      window.location.href = navigationRoutes.home
    }
  }, [])

  return (
    <ExcelUploadProvider merchantTargetId={merchant?.id} repository={createApiTpvRepository()}>
      <TpvExcelPageInner />
    </ExcelUploadProvider>
  )
}
